import React from 'react'

const PromotionListLayout = ({ children }) => (
  <div className="box">
    <div className="content">{children}</div>
  </div>
)

export default PromotionListLayout



// WEBPACK FOOTER //
// ./src/components/templates/promotion-list/PromotionListLayout.js